module.exports = __webpack_public_path__ + "static/img/file_c++.be29fe35.png";